import React, { useState, useEffect } from "react";
import Navbar from "../COMPONENT/Navbar/Navbar";
import Footer from "../COMPONENT/Footer/Footer";
import Loader from "../COMPONENT/Loader";
import Notfound from "./NotFound";
import {
  BsFacebook,
  BsInstagram,
  BsYoutube,
  BsTwitter,
  BsLinkedin,
} from "react-icons/bs";
import "../CSS/contact.css";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { setProducts, setURL } from "../store/storeDataSlice";
import axios from "axios";
import img from '../Images/contact.jpg'

function Contact() {
  const { name } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isLinkExist, setIsLinkExist] = useState(false);
  const { data } = useSelector((state) => state.product);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_API}/get-store`,
          { businessLink: name }
        );
        setLoading(false);
        if (response.data.message === "Invalid URL") {
          setIsLinkExist(false);
        } else if (response.data.message === "Valid URL") {
          setIsLinkExist(true);
          dispatch(setProducts(response.data.data));
          dispatch(setURL(name));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [name, dispatch]);
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {isLinkExist ? (
            <>
              <Navbar />
              <div className="main-container">
                <div className="main-box">
                  <div className="contact-section">
                    <h1>Contact Information</h1>
                    <ul className="info-list">
                      <li>
                        <strong>Address:</strong>
                        {data.storeDetails && data.storeDetails[0].address
                          ? data.storeDetails[0].address
                          : ""}
                      </li>
                      <li>
                        <strong>State:</strong>{" "}
                        {data.storeDetails && data.storeDetails[0].state
                          ? data.storeDetails[0].state
                          : ""}
                      </li>
                      <li>
                        <strong>City/Town:</strong>{" "}
                        {data.storeDetails && data.storeDetails[0].city_town
                          ? data.storeDetails[0].city_town
                          : ""}
                      </li>
                      <li>
                        <strong>Pincode:</strong>{" "}
                        {data.storeDetails && data.storeDetails[0].pincode
                          ? data.storeDetails[0].pincode
                          : ""}
                      </li>
                      <li>
                        <strong>Phone:</strong>{" "}
                        {data.customerSupport &&
                        data.customerSupport[0].supportMobileNumber
                          ? data.customerSupport[0].supportMobileNumber
                          : ""}
                      </li>
                      <li>
                        <strong>Email:</strong>{" "}
                        {data.customerSupport &&
                        data.customerSupport[0].supportEmailAddress
                          ? data.customerSupport[0].supportEmailAddress
                          : ""}
                      </li>
                    </ul>
                    <div className="social-icons">
                      <h2>Connect With Us</h2>
                      <div className="icons">
                        <a
                          href={
                            data.socialProfile && data.socialProfile[0].facebook
                              ? data.socialProfile[0].facebook
                              : "#"
                          }
                          className="icon"
                        >
                          <BsFacebook className="social-icon" />
                        </a>
                        <a
                          href={
                            data.socialProfile &&
                            data.socialProfile[0].instagram
                              ? data.socialProfile[0].instagram
                              : "#"
                          }
                          className="icon"
                        >
                          <BsInstagram className="social-icon" />
                        </a>

                        <a
                          href={
                            data.socialProfile && data.socialProfile[0].twitter
                              ? data.socialProfile[0].twitter
                              : "#"
                          }
                          className="icon"
                        >
                          <BsTwitter className="social-icon" />
                        </a>
                        <a
                          href={
                            data.socialProfile && data.socialProfile[0].youtube
                              ? data.socialProfile[0].youtube
                              : "#"
                          }
                          className="icon"
                        >
                          <BsYoutube className="social-icon" />
                        </a>
                        <a
                          href={
                            data.socialProfile && data.socialProfile[0].linkedin
                              ? data.socialProfile[0].linkedin
                              : "#"
                          }
                          className="icon"
                        >
                          <BsLinkedin className="social-icon" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="contact-form">
                    <img src={img} alt="contact" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                    {/* <h1>Contact Us</h1>
                    <form>
                      <input type="text" placeholder="Name" />
                      <input type="tel" placeholder="Phone" />
                      <input type="email" placeholder="Email" />
                      <textarea placeholder="Message"></textarea>
                      <button type="submit">Send Message</button>
                    </form> */}
                  </div>
                </div>
              </div>
              <Footer />
            </>
          ) : (
            <Notfound />
          )}
        </>
      )}
    </>
  );
}

export default Contact;
